import useMeaQuery from "qpr-base/apihooks/useMeaQuery";

export const useMeasurementUnitQueries = (modelId: string) => {
  const { data: unitData, isLoading: unitLoading } = useMeaQuery<any[]>(
    `[${modelId}].unit`,
    'name,value(series="JS_ATTR", period="firsforseries",as="translations"),symbol,unitsymbol,description'
  );
  const { data: unitDataTranslations, isLoading: translationsLoading } =
    useMeaQuery<any[]>(
      `[${modelId}].bySymbol(symbol="UNIT_METADATA")`,
      'name,value(series="JS_ATTR", period="firstforseries",as="translations"),symbol,unitsymbol,description'
    );

  const { data: measurementCycleData } = useMeaQuery<any[]>(
    `[SC].models(criteria="Find(\\"DP2030\\", name)").BySymbol(symbol="CONF_MEASUREMENT_CYCLE")`,
    'value(series="JS_ATTR",period="firstforseries")'
  );
  const { data: collectionCycleData } = useMeaQuery<any[]>(
    `[SC].models(criteria="Find(\\"DP2030\\", name)").BySymbol(symbol="CONF_COLLECTION_CYCLE")`,
    'value(series="JS_ATTR",period="firstforseries")'
  );

  const measurementCycle = measurementCycleData?.data[0]?.value
    ? JSON.parse(measurementCycleData?.data[0].value)
    : [];
  const collectionCycle = collectionCycleData?.data[0]?.value
    ? JSON.parse(collectionCycleData?.data[0].value)
    : [];

  return {
    unitDataTranslations,
    translationsLoading,
    unitData,
    unitLoading,
    measurementCycle,
    collectionCycle,
  };
};

export const getMeasurementDetails = (
  unitId: string,
  unitData:
    | {
        data: any[];
      }
    | undefined,
  unitDataTranslations:
    | {
        data: any[];
      }
    | undefined
) => {
  const unit = unitData?.data.find((e: any) => e.id === unitId);
  if (!unit) {
    return {};
  }
  const translatedUnits = JSON.parse(
    unitDataTranslations?.data[0]?.translations || ""
  );
  const unitTranslations = translatedUnits.find(
    (unitTranslation: any) => unitTranslation["Unit Name"] === unit?.name
  );
  return { unit, unitTranslations };
};
